import { HttpRequest } from 'types/interfaces';
import { getCsrfHeader } from 'utils/productFormUtils';

const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const hasNoResponseBody = (response: Response): boolean => {
  const contentLength = response.headers?.get('content-length');
  return response.status === 204 || response.status === 205 || contentLength === '0';
};

export const callRequest = async <S>(callConfigs: HttpRequest): Promise<S> => {
  const { url, method, headers, body, resType = 'json', init = {} } = callConfigs;

  let response: Response;
  try {
    response = await fetch(url, {
      method,
      credentials: 'include',
      headers: {
        ...HEADERS,
        ...getCsrfHeader(),
        ...(headers ? headers : {}),
      },
      body,
      ...init,
    });
  } catch (err) {
    return Promise.reject(err);
  }

  if (response.ok) {
    if (method === 'DELETE' || hasNoResponseBody(response)) {
      return Promise.resolve({} as S);
    }
    return response[resType]();
  } else {
    let errorResponse = {};
    try {
      errorResponse = await response.json();
      console.error(errorResponse);
    } catch (e) {
      console.error('Error parsing response body', e);
      errorResponse = {};
    }

    const error = Object.assign(response, { response: errorResponse });
    return Promise.reject(error);
  }
};
